import { AccountPricesForm } from './form-wrapper.component'
import { ModalWrapper } from 'src/components/modal-wrapper'
import { useStyles } from '../styles'

interface IProps {
  open: boolean
  handleClose: () => void
  accountId: string | null
}

export const AccountPricesModal = ({ open, handleClose, accountId }: IProps) => {
  const classes = useStyles()

  if (!accountId) return null

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <AccountPricesForm accountId={accountId} handleClose={handleClose} />
    </ModalWrapper>
  )
}
